import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function getOrgFinancialMetrics() {
  return fetcher.get({
    path: '/metrics/financials/organization',
  });
}
export async function updateOrgFinancialMetrics(data) {
  return fetcher.put({
    path: '/metrics/financials/organization',
    body: data,
  });
}

export async function createOrgFinancialMetrics(data) {
  return fetcher.post({
    path: '/metrics/financials/organization',
    body: data,
  });
}
